<template>
  <div>
    <div class="form-group">
      <div class="upload-wrapper" @dragover.prevent @drop.prevent="drop">
        <input
          id="assetsFieldHandle"
          ref="file"
          type="file"
          class="file-field"
          accept="image/*"
          @change="onChange"
        />

        <label v-if="file === ''" for="assetsFieldHandle" class="label-holder">
          <div v-html="labels.uploadLabel"></div>
        </label>
        <div v-if="file !== ''" v-cloak class="mt-4">
          {{ file.name }} ({{ file.size | kb }} kb)
        </div>
      </div>
      <input type="hidden" name="signature" :value="dataURL" />
    </div>
    <div class="form-group">
      <button
        type="submit"
        class="btn btn-primary btn-lg"
        :disabled="isDisabled"
      >
        {{ labels.agree }}
      </button>
    </div>
  </div>
</template>

<script>
import tectoastr from 'tectoastr';
export default {
  filters: {
    kb(val) {
      return Math.floor(val / 1024);
    }
  },
  props: {
    labels: {
      type: Object,
      required: true
    },
    canSign: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      file: '',
      dataURL: ''
    };
  },
  computed: {
    isDisabled() {
      return this.file === '' || (this.file && !this.isValidSignatureFile());
    }
  },
  methods: {
    isValidSignatureFile() {
      return ['image/png', 'image/jpeg', 'image/jpg'].includes(this.file.type);
    },
    onChange(event) {
      this.file = (typeof this.file !== "undefined" && this.file !== '') ? this.file :  event.target.files[0];
      if (this.file && !this.isValidSignatureFile()) {
        tectoastr.warning(this.labels.uploadWarning);
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        this.dataURL = reader.result;
      };
      reader.readAsDataURL(this.file);
    },
    drop(event) {
      event.preventDefault();
      this.file = event.dataTransfer.files[0];

      this.onChange();
    }
  }
};
</script>
